import {clearOAuthFlowCookie} from './clearOAuthFlowCookie';
import {getCommonParentDomain} from './getCommonParentDomain';
import {readOAuthFlowCookie} from './readOAuthFlowCookie';
import {setOAuthFlowCookie} from './setOAuthFlowCookie';

const OAUTH_FLOW_MAX_AGE_SECONDS = 600;

export const writeOAuthFlowCookie = (
  flow: ReturnType<typeof readOAuthFlowCookie>[number],
  callbackUrl: string
) => {
  const hostname = window.location.hostname;
  const callbackHostname = new URL(callbackUrl).hostname;
  const commonDomain = getCommonParentDomain(hostname, callbackHostname);
  const domain = commonDomain.includes('.') ? commonDomain : '';
  clearOAuthFlowCookie();
  setOAuthFlowCookie(
    encodeURIComponent(JSON.stringify({verifier: flow.verifier, state: flow.state})),
    domain,
    OAUTH_FLOW_MAX_AGE_SECONDS
  );
};
